/**
 * imageMap – Single source of truth for all image paths.
 * Every component must reference images through this map.
 */
export const imageMap: Record<string, string> = {
    /* ── HOME ── */
    "hero": "/images/home/hero.png",
    "hero-web": "/images/banners/hero-web-new.png",
    "hero-tablet": "/images/banners/hero-tablet-new.png",
    "hero-mobile": "/images/banners/hero-mobile-new.png",
    "hero-winding-road": "/images/banners/hero-winding-road.jpeg",
    "ambiente": "/images/home/Diseno-sin-titulo-3.png",
    "espiritu": "/images/home/Diseno-sin-titulo-2.png",
    "fraga-panoramica": "/images/home/gen_-_fraga_panoramica.jpg",
    "fraga-captura": "/images/home/Captura-1280x527.jpg",
    "viladoms": "/images/home/Viladoms-Station.png",
    "xavi": "/images/home/Xavi-XGbasics.png",

    // New Landing Page Images
    "redefining-collage-1": "/images/home/2book moto.jpeg",
    "redefining-collage-2": "/images/home/final-1280x699.png",
    "fraga-collage-1": "/images/home/gen_-_fraga_panoramica.jpg",
    "fraga-collage-2": "/images/home/Captura-1280x527.jpg",

    // Routes & Icons
    "onroad-route": "/images/home/Diseno-sin-titulo-2.png",
    "logo-offroad": "/images/inscripcion/PILOTO-OFF-980x980.png",
    "logo-onroad": "/images/inscripcion/PILOTO-ON-980x980.png",
    "logo-main": "/images/logos/logo-color.png",
    "logo-white": "/images/logos/logo-white.png",
    "icon-wheel": "/images/logos/logo-color.png",

    /* ── NOVEDADES ── */
    "novedades-hero": "/images/novedades/hero.webp", // User provided image
    "news-offroad": "/images/novedades/WhatsApp-Image-2026-02-11-at-18.57.13-1280x939.jpeg",
    "news-inscripciones": "/images/novedades/ABRIMOS-INSCRIPCIONES_MONEGROSBOOK-OK-1280x956.png",
    "news-comunidad": "/images/novedades/post-de-vacaciones-oferta-viaje-celeste-1-1.png",

    /* ── INSCRIPCIÓN ── */
    "inscripcion-hero": "/images/inscripcion/Gemini_Generated_Image_a6hewqa6hewqa6he-1-1280x740.png",
    "programa-hero": "/images/home/final-1280x699.png", // Updated to match Novedades hero (redefining-collage-2)
    "piloto-off": "/images/inscripcion/PILOTO-OFF-980x980.png",
    "piloto-on": "/images/inscripcion/PILOTO-ON-980x980.png",
    "onroad-new": "/images/home/hero.png", // Added placeholder for missing key
    "acompanante": "/images/inscripcion/ACOMPANANTE-1-980x980.png",
    "alojamientos-hero": "/images/home/gen_-_fraga_panoramica.jpg",
    "colaboradores-hero": "/images/colaboradores/partnership.png",
};
